// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { getCurrentDistributor, getToken } from '@/utils/auth';
import { Distributor, Product } from '@/pages/OrderList/data';

const getAuthHeaders = (): any => ({
  Authorization: `Bearer ${getToken()}`,
  'x-luxsol-distributor-id': getCurrentDistributor(),
});

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.CurrentUser>(`${BASE_URL}/users/me`, {
    method: 'GET',
    headers: getAuthHeaders(),
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${BASE_URL}/login/outLogin`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(
  body: { externalId: string | undefined; password: string | undefined },
  options?: { [key: string]: any },
) {
  return request<API.LoginResult>(`${BASE_URL}/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>(`${BASE_URL}/notices`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>(`${BASE_URL}/rule`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>(`${BASE_URL}/rule`, {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>(`${BASE_URL}/rule`, {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${BASE_URL}/rule`, {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

export async function getUsers() {
  return request<Distributor[]>(`${BASE_URL}/users`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
}

/** Get product list GET /api/products */
export async function getProducts(
  params: {
    /** Current page */
    current?: number;
    /** Page size */
    pageSize?: number;
    /** Keyword for search */
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    products: Product[];
    /** Total number of items */
    total?: number;
    success?: boolean;
  }>(`${BASE_URL}/products`, {
    method: 'GET',
    params: {
      ...params,
    },
    headers: getAuthHeaders(),
    ...(options || {}),
  });
}

/** Add product POST /api/products */
export async function addProduct(data: API.ProductItem, options?: { [key: string]: any }) {
  return request<API.ProductItem>(`${BASE_URL}/products`, {
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

/** Update product PUT /api/products/{id} */
export async function updateProduct(
  id: string,
  data: Partial<API.ProductItem>,
  options?: { [key: string]: any },
) {
  return request<API.ProductItem>(`${BASE_URL}/products/${id}`, {
    method: 'PUT',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

/** Delete product DELETE /api/products/{id} */
export async function removeProduct(id: string, options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${BASE_URL}/products/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

/** Batch delete products DELETE /api/products */
export async function batchRemoveProducts(ids: string[], options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${BASE_URL}/products/batch`, {
    method: 'DELETE',
    data: { ids },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

/** Get order list GET /api/orders */
export async function getOrders(
  params: {
    /** Page number (1-indexed) */
    page?: number;
    /** Page size */
    size?: number;
    /** Sort field - only "updatedTime" or "projectedDeliveryTime" */
    sortBy?: string;
    /** Sort order - "asc" or "desc" */
    sortOrder?: string;
    /** Confirmed time start */
    confirmedTimeFrom?: string;
    /** Confirmed time end */
    confirmedTimeTo?: string;
    /** Projected delivery time start */
    projectedDeliveryTimeFrom?: string;
    /** Projected delivery time end */
    projectedDeliveryTimeTo?: string;
    /** Search by order number */
    searchOrderNumber?: string;
    /** Search by custom order number */
    searchCustomOrderNumber?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    total: number;
    data: API.OrderItem[];
  }>(`${BASE_URL}/orders`, {
    method: 'GET',
    params: {
      ...params,
    },
    headers: getAuthHeaders(),
    ...(options || {}),
  });
}

/** Get order detail GET /api/orders/{id} */
export async function getOrder(id: string, options?: { [key: string]: any }) {
  return request<API.OrderItem>(`${BASE_URL}/orders/${id}`, {
    method: 'GET',
    headers: getAuthHeaders(),
    ...(options || {}),
  });
}

/** Update an existing order */
export async function updateOrder(id: string, params: API.OrderItem) {
  console.log('updateOrder', id, params);
  return request<API.OrderItem>(`${BASE_URL}/orders`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    data: params,
  });
}

export async function deleteOrder(id: string) {
  console.log('delete order', id);
  return request(`${BASE_URL}/orders/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  });
}

/** Confirm an order */
export async function confirmOrder(id: string) {
  return request<API.OrderItem>(`${BASE_URL}/orders/${id}/confirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: {},
  });
}

export async function unconfirmOrder(id: string) {
  return request(`${BASE_URL}/orders/${id}/unconfirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: {},
  });
}

export async function requestOnDemandOrderExport(id: string) {
  return request(`${BASE_URL}/orders/${id}/export/ondemand`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  });
}

export async function getExportOrderUrl(id: string) {
  return request(`${BASE_URL}/orders/${id}/export`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  });
}

export async function createOrUpdateOrder(params: API.OrderItem) {
  return request<API.OrderItem>(`${BASE_URL}/orders`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    data: params,
  });
}

/** Request reset password POST /auth/request-reset-password */
export async function requestPasswordReset(userExternalId: string) {
  return request(`${BASE_URL}/auth/request-reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: { userExternalId },
  });
}

/** Reset password POST /auth/reset-password */
export async function resetPassword(params: {
  userExternalId: string;
  nonce: string;
  password: string;
}) {
  return request<API.LoginResult>(`${BASE_URL}/auth/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

/** Get drawing URL for a line item */
export async function getLineItemDrawing(orderId: string, itemNumber: number) {
  return request<{ drawingUrl: string }>(
    `${BASE_URL}/orders/${orderId}/line-items/${itemNumber}/drawing`,
    {
      method: 'GET',
      headers: getAuthHeaders(),
    },
  );
}

export async function uploadLineItemDrawing(orderId: string, itemNumber: number) {
  return request<API.FileUploadResponse>(
    `${BASE_URL}/orders/${orderId}/line-items/${itemNumber}/drawing`,
    {
      method: 'POST',
      headers: getAuthHeaders(),
    },
  );
}

export async function requestLineItemsDrawings(orderId: string, itemNumbers: number[]) {
  return request(`${BASE_URL}/orders/${orderId}/drawings/request`, {
    method: 'POST',
    headers: getAuthHeaders(),
    data: {
      lineItemNumbers: itemNumbers,
    },
  });
}

export async function importOrder(orderId: string, file: File) {
  const response = await request<API.UploadUrlResponse>(`${BASE_URL}/orders/import/${orderId}`, {
    method: 'POST',
    data: {},
    headers: getAuthHeaders(),
  });
  const { id, uploadUrl } = response;
  await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
  });
  return id;
}

/** Get order upload status GET /api/orders/{orderId}/upload-status/{orderUploadId} */
export async function getOrderUploadStatus(orderUploadId: string) {
  return request<{
    status: string;
    progress: number;
    message?: string;
  }>(`${BASE_URL}/orders/import/${orderUploadId}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

/** Request file upload URL POST /api/files */
export async function requestFileUpload(fileName: string) {
  return request<API.FileUploadResponse>(`${BASE_URL}/files`, {
    method: 'POST',
    data: {
      name: fileName,
    },
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  });
}

/** Upload file to the provided URL */
export async function uploadFileToUrl(
  uploadUrl: string,
  file: File,
  uploadHiddenFields?: API.FileUploadHiddenField[],
) {
  const formData = new FormData();
  formData.append('file', file);

  // Add hidden fields if provided
  if (uploadHiddenFields && uploadHiddenFields.length > 0) {
    uploadHiddenFields.forEach((field) => {
      formData.append(field.fieldName, field.fieldValue);
    });
  }
  console.log('formData to submit', formData);

  return request(uploadUrl, {
    method: 'POST',
    data: formData,
    headers: {
      // Don't set Content-Type for FormData, let the browser set it with boundary
    },
  });
}

/** Upload file using AWS S3 presigned POST */
export async function uploadFileToS3(
  file: File,
  uploadResponse: API.FileUploadResponse,
  options: {
    fileOnly: boolean;
    method: 'POST' | 'PUT';
  } = { fileOnly: false, method: 'POST' },
) {
  console.log('uploadFileToS3 called with:', {
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    uploadUrl: uploadResponse.uploadUrl,
    hiddenFieldsCount: uploadResponse.uploadHiddenFields?.length || 0,
  });

  // Determine Content-Type based on file extension for S3 policy
  const getContentType = (fileName: string): string => {
    const ext = fileName.toLowerCase().split('.').pop();
    switch (ext) {
      case 'pdf':
        return 'application/pdf';
      case 'jpg':
      case 'jpeg':
        return 'image/jpg';
      case 'png':
        return 'image/png';
      default:
        return 'application/octet-stream';
    }
  };

  const contentType = getContentType(file.name);
  console.log('Determined Content-Type for S3 policy:', contentType);

  const formData = new FormData();

  if (!options.fileOnly) {
    // Add Content-Type field for S3 policy compliance
    // Check if Content-Type is already in hidden fields (case-insensitive)
    const hasContentType = uploadResponse.uploadHiddenFields?.some((field) => {
      const isContentType =
        field.fieldName.toLowerCase() === 'content-type' || field.fieldName === 'Content-Type';
      if (isContentType) {
        console.log('Found existing Content-Type field:', field.fieldName, field.fieldValue);
      }
      return isContentType;
    });

    console.log('Content-Type check result:', { hasContentType, contentType });

    if (!hasContentType) {
      console.log('Adding Content-Type field for S3 policy:', contentType);
      formData.append('Content-Type', contentType);
      console.log('Content-Type field added successfully');
    } else {
      console.log('Content-Type already provided in hidden fields');
    }
    // Add all the fields from the presigned POST response FIRST
    if (uploadResponse.uploadHiddenFields && uploadResponse.uploadHiddenFields.length > 0) {
      console.log('Adding hidden fields:', uploadResponse.uploadHiddenFields);
      uploadResponse.uploadHiddenFields.forEach((field) => {
        console.log('Adding field:', field.fieldName, field.fieldValue);
        formData.append(field.fieldName, field.fieldValue);
      });
    } else {
      console.log('No hidden fields to add');
    }
  }

  // Add the file LAST
  console.log('Adding file to FormData:', file.name, file.size, file.type);
  formData.append('file', file);

  // Debug: Check what's in the FormData
  console.log('FormData contains the following entries (order is important):');
  let entryCount = 0;
  for (const [key, value] of formData.entries()) {
    console.log(
      `Entry ${++entryCount}:`,
      key,
      value instanceof File ? `File: ${value.name}` : value,
    );
  }
  console.log(`Total FormData entries: ${entryCount}`);

  // Upload to S3 using the presigned POST URL
  console.log('Uploading to S3 URL:', uploadResponse.uploadUrl);
  const response = await fetch(uploadResponse.uploadUrl, {
    method: options.method,
    body: formData,
  });

  console.log('S3 upload response status:', response.status, response.statusText);

  if (!response.ok) {
    const errorText = await response.text();
    console.error('S3 upload failed:', errorText);
    throw new Error(`Upload failed with status: ${response.status} - ${errorText}`);
  }

  console.log('S3 upload successful!');
  return response;
}

export async function downloadOrderFile(orderId: string, fileIndex: number): Promise<string> {
  return (
    await fetch(`${BASE_URL}/orders/${orderId}/files/${fileIndex}`, {
      method: 'GET',
      headers: getAuthHeaders(),
    })
  ).json();
}

const BASE_URL = 'https://api.luxsol.com.au';
